"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../..");
var useBoolean_1 = __importDefault(require("../../../../hooks/useBoolean"));
var Button_1 = __importDefault(require("../../../Button/Button"));
var LinkButton_1 = __importDefault(require("../../../Button/LinkButton"));
var Label_1 = require("../../../Label");
var Message_1 = require("../../../Message");
var Padder_1 = require("../../../Padder");
var Popup_1 = __importDefault(require("../../../Popup/Popup"));
var LeftPanelHeader_1 = __importDefault(require("../LeftPanelHeader"));
var ModalButtonsWrap_1 = __importDefault(require("../ModalButtonsWrap"));
var NoDataLabel_1 = __importDefault(require("../NoDataLabel"));
var PopupHeader_1 = __importDefault(require("../PopupHeader"));
var Utils_1 = require("../Utils");
var DetailZanikOpravneni_1 = __importDefault(require("./DetailZanikOpravneni"));
var PridatZanikOpravneni_1 = __importDefault(require("./PridatZanikOpravneni"));
var UpravitZanikOpravneni_1 = __importDefault(require("./UpravitZanikOpravneni"));
var ZanikWrap = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 2rem;\n\n  div:first-of-type {\n    margin-bottom: 20px;\n  }\n"], ["\n  padding: 2rem;\n\n  div:first-of-type {\n    margin-bottom: 20px;\n  }\n"])));
var StyledLabel = styled_components_1.default(Label_1.Label)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #1ca854;\n  padding: 8px 10px;\n  color: #ffffff;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: bold;\n  margin-bottom: 10px !important;\n"], ["\n  background-color: #1ca854;\n  padding: 8px 10px;\n  color: #ffffff;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: bold;\n  margin-bottom: 10px !important;\n"])));
var ModalGreenLabel = styled_components_1.default(StyledLabel)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 14px;\n  padding: 10px 12px;\n  margin-bottom: 0 !important;\n"], ["\n  font-size: 14px;\n  padding: 10px 12px;\n  margin-bottom: 0 !important;\n"])));
var ErrorLabel = styled_components_1.default(StyledLabel)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: #fe505d;\n  margin-bottom: 10px !important;\n"], ["\n  background-color: #fe505d;\n  margin-bottom: 10px !important;\n"])));
var SMessage = styled_components_1.default(Message_1.Message)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var PopupChildren = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  overflow: auto;\n  max-height: 430px;\n"], ["\n  overflow: auto;\n  max-height: 430px;\n"])));
var ZanikOpravneni = function (_a) {
    var _b;
    var zaniky = _a.zaniky, idSubjekt = _a.idSubjekt, refetch = _a.refetch, znalecValues = _a.znalecValues, tlumocnikValues = _a.tlumocnikValues, isKancelar = _a.isKancelar;
    var isOpen = useBoolean_1.default(false);
    var isAddNewOpen = useBoolean_1.default(false);
    var isEditOpen = useBoolean_1.default(false);
    var _c = react_1.useState(0), idToEdit = _c[0], setIdToEdit = _c[1];
    var apiUrl = __1.useConfig().apiUrl;
    var iszrUrl = __1.useConfig().iszrUrl;
    var deleteJSON = __1.useDeleteJSON(apiUrl + "/Zanik/Delete");
    var zmenOsobu = __1.usePostJSON(iszrUrl + "/ZmenOsobu");
    var _d = react_1.useState(), deleteMessage = _d[0], setDeleteMessage = _d[1];
    var handleAddNew = function () {
        isAddNewOpen.toggle();
        setDeleteMessage(undefined);
    };
    var handleEdit = function (id) {
        setIdToEdit(id);
        isEditOpen.toggle();
        setDeleteMessage(undefined);
    };
    var handleClose = function () {
        isOpen.setFalse();
        isAddNewOpen.setFalse();
        isEditOpen.setFalse();
        setIdToEdit(0);
        setDeleteMessage(undefined);
    };
    var handleSmazat = function (zanikOpravneni, dMessage, uzivatel) { return __awaiter(void 0, void 0, void 0, function () {
        var rosMessage, response, jinyZanik, zanikAPreruseni, zmenOsobuValues, zanikyError, rosResponseV1, rosResponse, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 10, , 11]);
                    rosMessage = void 0;
                    return [4 /*yield*/, deleteJSON([zanikOpravneni.id])];
                case 1:
                    response = _c.sent();
                    if (!__1.isRight(response)) return [3 /*break*/, 9];
                    if (!refetch) return [3 /*break*/, 3];
                    return [4 /*yield*/, refetch()];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3:
                    if (!!isKancelar) return [3 /*break*/, 8];
                    jinyZanik = response.value;
                    zanikAPreruseni = {
                        datumVznikuOpravneni: (_a = jinyZanik.datumZapisu) === null || _a === void 0 ? void 0 : _a.substring(0, 10),
                        datumZanikuOpravneni: (_b = jinyZanik.datumOd) === null || _b === void 0 ? void 0 : _b.substring(0, 10),
                        pozastaveniOpravneniBool: jinyZanik.aktivniPozastaveni,
                        datumZanikuPlatnost: jinyZanik.neplatnyZanik ? false : undefined,
                        uzivatel: uzivatel,
                    };
                    zmenOsobuValues = void 0;
                    // znalec
                    if (znalecValues) {
                        zmenOsobuValues = Utils_1.znalecValuesForROS(znalecValues, zanikAPreruseni);
                    }
                    zanikyError = void 0;
                    if (!tlumocnikValues) return [3 /*break*/, 6];
                    zmenOsobuValues = Utils_1.tlumocnikValuesForROS(tlumocnikValues, zanikAPreruseni);
                    if (!(zmenOsobuValues.DatumVznikuOpravneni && zmenOsobuValues.DatumZanikuOpravneni && zmenOsobuValues.DatumVznikuOpravneni > zmenOsobuValues.DatumZanikuOpravneni)) return [3 /*break*/, 6];
                    if (!!jinyZanik.jedenSubjekt) return [3 /*break*/, 5];
                    return [4 /*yield*/, zmenOsobu(__assign(__assign({}, zmenOsobuValues), { DatumVznikuOpravneni: undefined }))];
                case 4:
                    rosResponseV1 = _c.sent();
                    if (!__1.isRight(rosResponseV1))
                        zanikyError = rosResponseV1.value.message;
                    _c.label = 5;
                case 5:
                    zmenOsobuValues = __assign(__assign({}, zmenOsobuValues), { DatumZanikuOpravneni: undefined });
                    _c.label = 6;
                case 6:
                    if (!(zmenOsobuValues.DatumVznikuOpravneni || zmenOsobuValues.DatumZanikuOpravneni)) return [3 /*break*/, 8];
                    return [4 /*yield*/, zmenOsobu(zmenOsobuValues)];
                case 7:
                    rosResponse = _c.sent();
                    if (!zanikyError && __1.isRight(rosResponse))
                        rosMessage = { message: 'Referenční údaje byly úspěšně aktualizovány v ROS.', type: 'success' };
                    else
                        rosMessage = { message: zanikyError !== null && zanikyError !== void 0 ? zanikyError : rosResponse.value.message, type: 'error' };
                    _c.label = 8;
                case 8:
                    setDeleteMessage([rosMessage, { message: dMessage, type: 'success' }]);
                    _c.label = 9;
                case 9: return [2 /*return*/, response];
                case 10:
                    e_1 = _c.sent();
                    return [2 /*return*/, __1.Left(e_1.message)];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var getItem = function () {
        return zaniky === null || zaniky === void 0 ? void 0 : zaniky.find(function (x) { return x.id === idToEdit; });
    };
    var dateMinusOne = Date.now() - 3600 * 1000 * 24;
    var aktivniZanik = (zaniky === null || zaniky === void 0 ? void 0 : zaniky.find(function (item) {
        return (item.datumOd != null && item.datumDo === null && Date.now() >= Date.parse(item.datumOd)) ||
            (item.datumOd != null && item.datumDo != null && Date.parse(item.datumDo) >= dateMinusOne && Date.now() >= Date.parse(item.datumOd));
    })) != null;
    var disableAdd = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var minDate;
        var maxDate;
        if (znalecValues) {
            minDate = (_a = znalecValues.znalec.datumOpakovanehoZapisu) !== null && _a !== void 0 ? _a : znalecValues.znalec.datumZapisu;
            maxDate = (_e = (_d = (_c = (_b = znalecValues.preruseniCinnosti) === null || _b === void 0 ? void 0 : _b.zanikOpravneni) === null || _c === void 0 ? void 0 : _c.filter(function (t) { return t.datumOd && t.datumOd > minDate; })) === null || _d === void 0 ? void 0 : _d.slice(-1)[0]) === null || _e === void 0 ? void 0 : _e.datumOd;
        }
        if (tlumocnikValues) {
            minDate = (_f = tlumocnikValues.tlumocnik.datumOpakovanehoZapisu) !== null && _f !== void 0 ? _f : tlumocnikValues.tlumocnik.datumZapisu;
            maxDate = (_k = (_j = (_h = (_g = tlumocnikValues.preruseniCinnosti) === null || _g === void 0 ? void 0 : _g.zanikOpravneni) === null || _h === void 0 ? void 0 : _h.filter(function (t) { return t.datumOd && t.datumOd > minDate; })) === null || _j === void 0 ? void 0 : _j.slice(-1)[0]) === null || _k === void 0 ? void 0 : _k.datumOd;
        }
        var minDatePlus = new Date(minDate);
        minDatePlus.setDate(minDatePlus.getDate() + 1);
        return maxDate ? minDatePlus >= new Date(maxDate) : false;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ZanikWrap, null,
            react_1.default.createElement(LeftPanelHeader_1.default, null, "Z\u00E1nik opr\u00E1vn\u011Bn\u00ED"),
            !aktivniZanik && zaniky && zaniky.length > 0 && react_1.default.createElement(StyledLabel, { type: "green" }, "Opr\u00E1vn\u011Bn\u00ED je Aktivn\u00ED"),
            zaniky && zaniky.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                aktivniZanik && react_1.default.createElement(ErrorLabel, { type: "error" }, "Opr\u00E1vn\u011Bn\u00ED zaniklo"),
                zaniky.map(function (item) { return (react_1.default.createElement(DetailZanikOpravneni_1.default, { key: item.id, zanikOpravneni: item, handleEdit: handleEdit, refetch: refetch, handleSmazat: handleSmazat })); }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(NoDataLabel_1.default, null))),
            idSubjekt && (react_1.default.createElement(LinkButton_1.default, { type: "button", className: "button", onClick: isOpen.toggle }, "Spravovat"))),
        react_1.default.createElement(Popup_1.default, { open: isOpen.value, onClose: handleClose },
            isAddNewOpen.value && (react_1.default.createElement(PridatZanikOpravneni_1.default, { isKancelar: isKancelar, tlumocnikValues: tlumocnikValues, znalecValues: znalecValues, idSubjekt: idSubjekt !== null && idSubjekt !== void 0 ? idSubjekt : 0, handleClose: isOpen.setFalse, refetch: refetch, clenstvi: znalecValues === null || znalecValues === void 0 ? void 0 : znalecValues.clenstvi })),
            isEditOpen.value && (react_1.default.createElement(UpravitZanikOpravneni_1.default, { tlumocnikValues: tlumocnikValues, znalecValues: znalecValues, isKancelar: isKancelar, initialValues: getItem(), idSubjekt: idSubjekt !== null && idSubjekt !== void 0 ? idSubjekt : 0, handleClose: isOpen.setFalse, refetch: refetch })),
            !isEditOpen.value && !isAddNewOpen.value && (react_1.default.createElement(Padder_1.Padder, null,
                react_1.default.createElement(PopupHeader_1.default, null, "Z\u00E1nik opr\u00E1vn\u011Bn\u00ED"),
                ((_b = deleteMessage === null || deleteMessage === void 0 ? void 0 : deleteMessage.filter(function (d) { return d !== undefined; })) === null || _b === void 0 ? void 0 : _b.length) > 0 && (deleteMessage === null || deleteMessage === void 0 ? void 0 : deleteMessage.filter(function (d) { return d !== undefined; }).map(function (d, index) {
                    return (react_1.default.createElement(SMessage, { type: d === null || d === void 0 ? void 0 : d.type, onClose: function () {
                            setDeleteMessage(deleteMessage.filter(function (m) { return m !== deleteMessage[index]; }));
                        } }, d.message));
                })),
                react_1.default.createElement(PopupChildren, null,
                    !aktivniZanik && zaniky && zaniky.length > 0 && react_1.default.createElement(ModalGreenLabel, { type: "green" }, "Opr\u00E1vn\u011Bn\u00ED je Aktivn\u00ED"),
                    zaniky &&
                        zaniky.length > 0 &&
                        zaniky.map(function (item) { return (react_1.default.createElement(DetailZanikOpravneni_1.default, { tlumocnikValues: tlumocnikValues, znalecValues: znalecValues, isKancelar: isKancelar, key: item.id, zanikOpravneni: item, isModal: true, handleEdit: handleEdit, idSubjekt: idSubjekt !== null && idSubjekt !== void 0 ? idSubjekt : 0, refetch: refetch, handleSmazat: handleSmazat })); })),
                !aktivniZanik && !disableAdd() && (react_1.default.createElement(ModalButtonsWrap_1.default, null,
                    react_1.default.createElement(Button_1.default, { type: "button", primary: true, onClick: handleAddNew, name: "Zapsat" }, "Zapsat z\u00E1nik opr\u00E1vn\u011Bn\u00ED"))))))));
};
ZanikOpravneni.defaultProps = {
    zaniky: undefined,
    idSubjekt: undefined,
    refetch: undefined,
    znalecValues: undefined,
    tlumocnikValues: undefined,
    isKancelar: undefined,
};
exports.default = ZanikOpravneni;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
